import { message } from 'antd';
import { TRANSACTIONS } from '../containers/TemplateSection/translationValues';
import * as XLSX from 'xlsx';
import { XMLParser, XMLBuilder } from 'fast-xml-parser';
import { VARIABLE_OBJECT_TYPES, VARIABLE_TYPE } from './constants/appConstants';
import { convertExcelSerialDate } from './javascript';
import { dynamicTableHasMoreThanTwoLevels } from '../containers/ComplexDocumentDesign/complexDocumentHelper';
const fileExtension = [".xls", "xlsx"]
const supportedFileTypes = ['application/xml', 'text/xml', 'application/json'];

const checkFileFormat = (file, fileExtensions = fileExtension) => {
    const fileType = file.split('.').pop().toLowerCase();
    return fileExtensions.includes(fileType);
}

export const getXMLFromJSON = (json, variableContract) => {
  const options = {
    isArray: (tagName) => {
      const varDetails = variableContract.find(variable => variable.name === tagName);
      if (varDetails && VARIABLE_OBJECT_TYPES.includes(varDetails?.type)) {
        return true;
      }
      return false;
    }
  }
  const builder = new XMLBuilder(options);
  return builder.build(json);
}

const generateRepeatedBlockPayload = (excelData, template, isEmail = false, tagsData = undefined, isRepeatedBlocks, isChartBlock) => {
  let groupedData = {};

  excelData.forEach(item => {
    let { id, uniq_id, uniq_name, toEmailAddress, attachmentPassword, printable, ...rest } = item;
    let keyId = isEmail ? 'mailTemplateId' : 'documentId';

    if (!groupedData[id]) {
      groupedData[id] = { [keyId]: template.id, dataSet: {} };

      if (isEmail) {
        groupedData[id]['to'] = [toEmailAddress];
        groupedData[id]['attachmentPassword'] = attachmentPassword;
      } else {
        groupedData[id] = Object.assign({}, groupedData[id], {
          tagInfo: [],
          printable: printable ?? false,
        });
        if (typeof printable === 'string') groupedData[id].printable = printable === 'true' || printable === '1';
        else if (typeof printable === 'number') groupedData[id].printable = printable === 1;
      }
    }

    // Set uniq_id and uniq_name
    groupedData[id]['dataSet']['uniq_id'] = uniq_id ?? null;
    groupedData[id]['dataSet']['uniq_name'] = uniq_name ?? null;

    // Iterate over rest of the keys
    for (let propKey in rest) {
      const value = rest[propKey];

      // Check if this key is a chart object
      const isChartObject = template.variableContract?.some(v => v.name === propKey && v.content?.some(vc => vc.type === VARIABLE_TYPE.CHART_OBJECT));

      if (typeof value === VARIABLE_TYPE.OBJECT && !Array.isArray(value) && !isChartBlock) {
        if (!groupedData[id]['dataSet'][propKey]) groupedData[id]['dataSet'][propKey] = [];
        const currentArr = groupedData[id]['dataSet'][propKey];
        const incomingObj = value;
        if (!('table_id' in incomingObj)) {
          const dataArray = groupedData[id]['dataSet'][propKey];

          // Temporary storage to merge nested keys under same parent
          const parentMap = {};

          for (const [key, value] of Object.entries(incomingObj)) {
            const split = key.split('.');

            if (split.length === 2) {
              parentMap[propKey] = parentMap[propKey] || {};
              parentMap[propKey][key] = value;
            }
            else if (split.length === 3) {
              const parentKey = split[0];
              const midKey = split[1];
              const nestedKey = `${midKey}.${split[2]}`;

              // Ensure the parent and nested structure exist
              parentMap[parentKey] = parentMap[parentKey] || {};
              parentMap[parentKey][midKey] = parentMap[parentKey][midKey] || {};

              // Assign nested value
              parentMap[parentKey][midKey][nestedKey] = value;
            }
          }

          // Push all constructed parent objects into the final dataset
          for (const obj of Object.values(parentMap)) {
            dataArray.push(obj);
          }

          continue;
        }

        // Find existing object by table_id
        const existingObj = currentArr.find(obj => obj.table_id === incomingObj.table_id);

        if (existingObj) {
          const newObject = {};
          let arrKey;
          Object.keys(incomingObj).forEach(prop => {
            if (prop === 'table_id') return;
            const val = incomingObj[prop];

            // Check template for non-array fields
            let isNonArrayField = false;
            for (const v of template.variableContract) {
              if (v.content?.some(cont => cont.name === prop && !cont.isArray)) {
                isNonArrayField = true;
                break;
              }
            }

            // Handle dotted keys for repeated blocks
            if (!isNonArrayField && prop.includes('.')) {
              const parts = prop.split('.');
              const arrayKey = isRepeatedBlocks ? parts[0] : parts[1];
              arrKey = arrayKey;
              const innerKey = parts.slice(1).join('.');

              if (!newObject[arrayKey]) newObject[arrayKey] = [];
              const mergedObj = Object.assign({}, ...newObject[arrayKey]);
              newObject[arrayKey] = [{ [innerKey]: val, ...mergedObj }];
              return;
            }

            // Normal merge
            if (existingObj.hasOwnProperty(prop)) {
              if (Array.isArray(existingObj[prop])) {
                existingObj[prop].push({ [prop]: val });
              } else {
                existingObj[prop] = [{ [prop]: existingObj[prop] }, { [prop]: val }];
              }
            } else {
              existingObj[prop] = val;
            }
          });
          const targetObj = currentArr.find(cArr => existingObj.table_id === cArr.table_id);
          if (targetObj && Array.isArray(targetObj[arrKey]) && Array.isArray(newObject[arrKey])) {
            targetObj[arrKey].push(...newObject[arrKey]);
          }
        } else {
        // First object with this table_id
        const newObj = { table_id: incomingObj.table_id };
          Object.keys(incomingObj).forEach(prop => {
            if (prop === 'table_id') return;
            const val = incomingObj[prop];

            let isNonArrayField = false;
            for (const v of template.variableContract) {
              if (v.content?.some(cont => cont.name === prop && !cont.isArray)) {
                isNonArrayField = true;
                break;
              }
            }

            if (!isNonArrayField && prop.includes('.')) {
              const parts = prop.split('.');
              const arrayKey = isRepeatedBlocks ? parts[0] : parts[1];
              const innerKey = parts.slice(1).join('.');
              if(newObj[arrayKey] === undefined) {
                newObj[arrayKey] = [];
              }
              const mergedObj = Object.assign({}, ...newObj[arrayKey]);
              newObj[arrayKey] = [{ [innerKey]: val, ...mergedObj }];
            } else {
              newObj[prop] = val;
            }
          });
          currentArr.push(newObj);
        }

      } else if (typeof value === VARIABLE_TYPE.OBJECT && isChartBlock) {
        if (!groupedData[id]['dataSet'][propKey]) groupedData[id]['dataSet'][propKey] = [];
        if(Array.isArray(value)) {
          groupedData[id]['dataSet'][propKey].push(...value);
        } else {
          groupedData[id]['dataSet'][propKey].push(value);
        }

      } else {
        // Handle tags or normal values
        if (tagsData) {
          const tagsList = tagsData.map(item => item.tagName);
          if (tagsList.includes(propKey.replace(/_/g, ' '))) {
            groupedData[id]['tagInfo'].push({ tagName: propKey, tagValue: value });
          } else if (template.variableContract.find(v => v.name === propKey)) {
            groupedData[id]['dataSet'][propKey] = value;
          }
        } else if (template.variableContract.find(v => v.name === propKey)) {
          groupedData[id]['dataSet'][propKey] = value;
        }
      }
    }
  });

  // Transform groupedData into array
  return Object.keys(groupedData).map(key => {
    const obj = groupedData[key];
    if (!obj.dataSet.hasOwnProperty('uniq_id')) obj.dataSet.uniq_id = null;
    if (!obj.dataSet.hasOwnProperty('uniq_name')) obj.dataSet.uniq_name = null;
    return obj;
  });
};


const generatePayload = (excelData, template, isEmail = false, tagsData = undefined) =>
    excelData.map(obj => {
      let {uniq_id,uniq_name,
        toEmailAddress,
        attachmentPassword,
        printable,
        ...rest
      } = obj;

      let payload;
      if (isEmail) {
        payload = {
          mailTemplateId: template?.id,
          dataSet: { ...rest,uniq_id:uniq_id?uniq_id:null,uniq_name:uniq_name?uniq_name:null},
          to: [toEmailAddress],

        };
        delete payload.dataSet.to;
        if (attachmentPassword) {
          payload.attachmentPassword = attachmentPassword;
        }
      } else {
        payload = {
          documentId: template.id,
          tagInfo: [],
          dataSet: {},
          printable: printable ?? false,
        };
          if (typeof printable === 'string') {
            payload.printable = printable === 'true' || printable === '1';
          } else if (typeof printable === 'number') {
            payload.printable = printable === 1;
          }
        payload['dataSet']['uniq_id'] = uniq_id ? uniq_id : null
        payload['dataSet']['uniq_name'] = uniq_name ? uniq_name : null
      for (let key in rest) {
        if(tagsData) {
          const tagsList = tagsData.map(item => item.tagName);
          const removeUnderScore= key.replace(/_/g, ' ');
          if(tagsList.includes(removeUnderScore)) {
            payload['tagInfo'].push({ 'tagName': key.replace(/_/g, ' '), 'tagValue': rest[key] });
          } else {
            const variableDef = template.variableContract.find(variable => variable.name === key);
             if (variableDef) {
              if (variableDef.type === VARIABLE_TYPE.LIST_STRING || variableDef.type === VARIABLE_TYPE.LIST_OF_STRINGS) {
                if (Array.isArray(rest[key])) {
                  payload['dataSet'][key] = rest[key].map(s => String(s).trim());
                } else if (typeof rest[key] === "string") {
                  payload['dataSet'][key] = rest[key]
                    ? rest[key].split(',').map(s => s.trim())
                    : [];
                } else {
                  payload['dataSet'][key] = [];
                }
              } else {
                payload['dataSet'][key] = rest[key];
              }
            }
          }
        } else {
          const variableDef = template.variableContract.find(variable => variable.name === key);
             if (variableDef) {
              if (variableDef.type === VARIABLE_TYPE.LIST_STRING || variableDef.type === VARIABLE_TYPE.LIST_OF_STRINGS) {
                if (Array.isArray(rest[key])) {
                  payload['dataSet'][key] = rest[key].map(s => String(s).trim());
                } else if (typeof rest[key] === "string") {
                  payload['dataSet'][key] = rest[key]
                    ? rest[key].split(',').map(s => s.trim())
                    : [];
                } else {
                  payload['dataSet'][key] = [];
                }
              } else {
                payload['dataSet'][key] = rest[key];
              }
            }
        }
      }
      }
      return payload;
    });

export const generateSampleExcel = (template, isEmail = false, isMailRoomModuleEnabled = false, tagsData = undefined) => {
    const { variableContract } = template;

    const {isNestedTable} = dynamicTableHasMoreThanTwoLevels(variableContract);
    // Create a new workbook
    const wb = XLSX.utils.book_new();

    // Create a worksheet
    const ws = XLSX.utils.aoa_to_sheet([]);

    let isRepeated_Chart_Blocks = false; 
    if (template && variableContract.length > 0) {
      isRepeated_Chart_Blocks = template.variableContract.some(
        variable => (variable.type === VARIABLE_TYPE.OBJECT || variable.type === VARIABLE_TYPE.TABLE_OBJECT || variable.type === VARIABLE_TYPE.CHART_OBJECT) && variable.content.length > 0,
      );
    }

    // Add data to worksheet
    let col = 0;
    if (isRepeated_Chart_Blocks) {
      XLSX.utils.sheet_add_aoa(ws, [['id']], {
        origin: { r: 0, c: col++ },
      });
    }
    XLSX.utils.sheet_add_aoa(ws, [['uniq_id']], {
      origin: { r: 0, c: col++ },
    });
    XLSX.utils.sheet_add_aoa(ws, [['uniq_name']], {
      origin: { r: 0, c: col++ },
    });
    if (isEmail) {
      const header = ['To Email Address'];
      if (template?.passwordProtected ?? false) {
        header.push('Attachment Password');
      }
      header.forEach(item => {
        XLSX.utils.sheet_add_aoa(ws, [[item]], {
          origin: { r: 0, c: col },
        });
        col++;
      });
    }
    // Add main headers and subheaders
    variableContract.forEach(item => {
      if (item.type.toLowerCase() === VARIABLE_TYPE.STRING.toLowerCase()
        || item.type.toLowerCase() === VARIABLE_TYPE.LIST_OF_STRINGS.toLowerCase()
        || item.type.toLowerCase() === 'liststring'
        || item.type.toLowerCase() === VARIABLE_TYPE.DATE.toLowerCase()) {
        console.log("Coming here 1");
        XLSX.utils.sheet_add_aoa(ws, [[item.name]], {
          origin: { r: 0, c: col },
        });
        col++;
      } else if (item.type === VARIABLE_TYPE.OBJECT || item.type === VARIABLE_TYPE.TABLE_OBJECT || item.type === VARIABLE_TYPE.CHART_OBJECT) {
        console.log("Coming here 2");
        const addCell = (row, value) => {
          XLSX.utils.sheet_add_aoa(ws, [[value]], { origin: { r: row, c: col } });
        };
        
        item.content.forEach((subItem, indx) => {
          let isRepeatedBlocks = false;
          let isChartBlock = false;
          if (template && template.variableContract?.length > 0) {
            isRepeatedBlocks = template.variableContract.some(
              variable => variable.type === VARIABLE_TYPE.OBJECT && variable.content.length > 0,
            );
            isChartBlock = template.variableContract.some(
              variable => variable.content?.some(varl => varl.type === VARIABLE_TYPE.CHART_OBJECT&& varl.content.length > 0),
            );
          }
          if (subItem?.content && (isNestedTable || isRepeatedBlocks || isChartBlock)) {
            if ((item.type === VARIABLE_TYPE.OBJECT || item.type === VARIABLE_TYPE.TABLE_OBJECT)  && (subItem?.isArray || isRepeatedBlocks)) {
              addCell(0, item.name);
              addCell(1, `table_id`);
              col++;
            }

            if(isRepeatedBlocks) {
              let subItemName = subItem.name.split(".");
              subItem.content.forEach((innerChild) => {
              addCell(0, item.name);
              if(isChartBlock && subItem.type === VARIABLE_TYPE.CHART_OBJECT) {
                addCell(1, `${subItem.name}.${innerChild.name}`);
              } else {
                addCell(1, `${subItemName[1]}.${innerChild.name}`);
              }
              col++;
            });
            } else {
              subItem.content.forEach((innerChild) => {
                addCell(0, item.name);
                addCell(1, item.type === VARIABLE_TYPE.OBJECT ? innerChild.name : `${item.name}.${innerChild.name}`);
                col++;
              });
            }
        
          } else {
            addCell(0, item.name);
            addCell(1, subItem.name);
            col++;
          }
        });
        
      } else if (item.type === VARIABLE_TYPE.HTML) {
        XLSX.utils.sheet_add_aoa(ws, [[item.name]], {
          origin: { r: 0, c: col },
        });
        col++;
      } else {
        console.log("Coming here 3");
      }
    });
    if (!isEmail && isMailRoomModuleEnabled && tagsData) {
      const tags = tagsData.map(item => item.tagName);
      XLSX.utils.sheet_add_aoa(ws, [['printable', ...tags]], {
        origin: { r: 0, c: col++ },
      });
    }
    // Add worksheet to workbook
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

    // Generate Excel file
    XLSX.writeFile(wb, `${template.name || template.documentName}.xlsx`);
}

export const getPayloadFromFile = (binaryString, file, template, t, isEmail = false, isMailRoomModuleEnabled = false, tagsData = undefined) => {
    let isRepeatedBlocks = false, isChartBlock = false, isDynamicTable = false;
    const { variableContract } = template;

    const {isNestedTable} = dynamicTableHasMoreThanTwoLevels(variableContract);
    if (template && template.variableContract?.length > 0) {
      isRepeatedBlocks = template.variableContract.some(
        variable => variable.type === VARIABLE_TYPE.OBJECT && variable.content.length > 0,
      );
      isChartBlock = template.variableContract.some(
        variable => variable.type === VARIABLE_TYPE.CHART_OBJECT && variable.content.length > 0,
      );
      isDynamicTable = template.variableContract.some(
        variable => variable.type === VARIABLE_TYPE.TABLE_OBJECT && variable.content.length > 0,
      );
    }
    let expectedItems = [];
    const usedVariables = template?.variableContract;

    console.log({ isMailRoomModuleEnabled, tagsData });

    if (isEmail) {
      expectedItems.push(supportedFileTypes.includes(file.type) ? 'toEmailAddress' : 'To Email Address');
      if (template?.passwordProtected ?? false) {
        expectedItems.push(supportedFileTypes.includes(file.type) ? 'attachmentPassword' : 'Attachment Password');
      }
    }

    if (!supportedFileTypes.includes(file.type) && (isRepeatedBlocks || isChartBlock || isNestedTable || isDynamicTable)) {
      expectedItems.push('id');
    }

    usedVariables.forEach(item => {
      expectedItems.push(item.name);
    });
  console.log({ isEmail, expectedItems })
  if (checkFileFormat(file.name)) {
      const workbook = XLSX.read(binaryString, { type: 'binary' });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const Exceldata = XLSX.utils.sheet_to_json(sheet, { header: 1 });
      const data = Exceldata.filter(row => row.some(cell => cell !== undefined && cell !== null && cell !== ''));
      // Assuming the first row contains headers
      const headers = data[0];
      const subHeaders = isRepeatedBlocks || isChartBlock || isDynamicTable || isNestedTable ? data[1] : undefined;
      const rows = data.slice(isRepeatedBlocks || isChartBlock || isDynamicTable || isNestedTable ? 2 : 1); // Exclude header row
      console.log({ headers, rows });

      // Get the variable name if the content is empty
      const emptyContentNames = template.variableContract
        .filter(item => VARIABLE_OBJECT_TYPES.includes(item.type) && item.content && item.content.length === 0)
        .map(item => item.name);

      headers.push(...emptyContentNames);
      const allItemsPresent = expectedItems.every(item => headers.includes(item));
      if (!allItemsPresent) {
        message.error(
          t(
            `TRANSACTIONS:${TRANSACTIONS.PROVIDED_DATA_INVALID_ERROR_MESSAGE.key}`,
            TRANSACTIONS.PROVIDED_DATA_INVALID_ERROR_MESSAGE.value,
          ),
        );
        return;
      }

      let dataIndex;

      if (rows.flat().length < 1) {
        message.error(
          t(
            `TRANSACTIONS:${TRANSACTIONS.EMPTY_DATE_ERROR_MESSAGE.key}`,
            TRANSACTIONS.EMPTY_DATE_ERROR_MESSAGE.value
          ),
        );
        return;
      }
      let excelData = rows
        .flatMap(row => {
          const rowData = [];
          let obj = {};
          row.forEach((cellData, index) => {
            const cell = cellData.toString();
            if (headers[index] === 'id') {
              dataIndex = cell;
              obj = {};
            }
            if (headers[index] && (subHeaders === undefined || subHeaders[index] === undefined)) {
              const isListOfStrings = template.variableContract.some(
                variable =>
                  variable.name === headers[index] &&
                  (variable.type === VARIABLE_TYPE.LIST_OF_STRINGS || variable.type === 'ListString'),
              );
              const isDate = template.variableContract.some(
                variable =>
                  variable.name === headers[index] &&
                  variable.type === 'date',
                );
                obj[headers[index]] = isListOfStrings ? cell.split(',') : isDate ? convertExcelSerialDate(cell) : cell;
            }
            if (headers[index] && subHeaders !== undefined && subHeaders[index] !== undefined) {
              if (!obj[headers[index]]) {
                obj[headers[index]] = {};
              }
              const isListOfStrings = template.variableContract.some(variable =>
                variable.name === headers[index] &&
                (variable.type === VARIABLE_TYPE.OBJECT || variable.type === VARIABLE_TYPE.TABLE_OBJECT) &&
                variable.content?.some(subVar => {
                  if (subVar.name === subHeaders[index] &&
                    (subVar.type === VARIABLE_TYPE.LIST_OF_STRINGS || subVar.type === 'ListString')) {
                    return true;
                  }

                  if (subVar.isArray && subVar.content) {
                    return subVar.content.some(
                      sbVar =>
                        `${variable.name}.${sbVar.name}` === subHeaders[index] &&
                        (sbVar.type === VARIABLE_TYPE.LIST_OF_STRINGS || sbVar.type === 'ListString')
                    );
                  }

                  return false;
                })
              );
              const isDate = template.variableContract.some(variable =>
                variable.name === headers[index] &&
                variable.type === VARIABLE_TYPE.OBJECT &&
                variable.content?.some(subVar => {
                  if (subVar.name === subHeaders[index] && subVar.type === 'date') {
                    return true;
                  }

                  if (subVar.isArray && subVar.content) {
                    return subVar.content.some(
                      sbVar =>
                        `${variable.name}.${sbVar.name}` === subHeaders[index] &&
                        sbVar.type === 'date'
                    );
                  }

                  return false;
                })
              );

              obj['id'] = dataIndex;
              obj[headers[index]][subHeaders[index]] = isListOfStrings ? cell.split(',') : isDate ? convertExcelSerialDate(cell) : cell;
            }
          });
          obj['toEmailAddress']=obj['To Email Address']
          obj['attachmentPassword']=obj['Attachment Password']
          delete obj['To Email Address'];
          delete obj['Attachment Password'];
          rowData.push(obj);  
          return rowData;
        })
        .filter(row => Object.keys(row).length !== 0);
      
        // If the object and chartObject content is empty, manually create an empty array and push it into the excelData
          excelData.forEach(obj => {
          emptyContentNames.forEach(value => {
            obj[value] = [];
          });
        });
      const payload =
        isRepeatedBlocks || isChartBlock || isDynamicTable || isNestedTable
          ? generateRepeatedBlockPayload(excelData, template, isEmail, tagsData, isRepeatedBlocks, isChartBlock)
          : generatePayload(excelData, template, isEmail, tagsData);
    return payload;
  } else if (file.type === 'application/json') {
    const contents = JSON.parse(binaryString);
    if (!Array.isArray(contents)) {
        message.error(
          t(
            `TRANSACTIONS:${TRANSACTIONS.PROVIDED_DATA_INVALID_ERROR_MESSAGE.key}`,
            TRANSACTIONS.PROVIDED_DATA_INVALID_ERROR_MESSAGE.value,
          ),
        );
      return;
    }
    const payload = contents.map((request, index) => {
      if (isEmail) {
        const { toEmailAddress, attachmentPassword, ...rest } = request;
        return Object.assign({}, {
          to: [toEmailAddress],
          attachmentPassword,
          toEmailAddress,
          id: index,
          ...rest,
        })
      }
      return Object.assign({}, request, { id: index });
    });
    // TODO : Check if all values are present
    const allItemsPresent = expectedItems.every(key => Object.keys(contents[0]).includes(key));
    if (!allItemsPresent) {
        message.error(
          t(
            `TRANSACTIONS:${TRANSACTIONS.PROVIDED_DATA_INVALID_ERROR_MESSAGE.key}`,
            TRANSACTIONS.PROVIDED_DATA_INVALID_ERROR_MESSAGE.value,
          ),
        );
        console.log("missing items :: ", expectedItems.filter(key => !Object.keys(contents[0]).includes(key)));
        return;
    }

      const dataset =
        isRepeatedBlocks || isChartBlock
          ? generateRepeatedBlockPayload(payload, template, isEmail, tagsData)
          : generatePayload(payload, template, isEmail, tagsData);
      return dataset;

  } else if (file.type === 'application/xml' || file.type === 'text/xml') {
  const options = {
    numberParseOptions: {
      skipLike: /[0-9]+/
    },
    stopNodes: template?.variableContract?.map(v => {
      if (v.type === 'html') {
        return `*.${v.name}`;
      }
    }).filter(v => !!v),
    isArray: (tagName) => {
      const varDetails = template.variableContract?.find(variable => variable.name === tagName); // Expecting name always, since these are mostly local variables
      if (varDetails && VARIABLE_OBJECT_TYPES.includes(varDetails?.type)) {
        return true;
      } else if (tagName === 'request') {
        return true;
      }
      return false;
    }
  };
    const xmlParser = new XMLParser(options);
    let jObj = xmlParser.parse(binaryString);
    console.log("jObj :: ", jObj);
    // TODO : Check if all values are present
    const allItemsPresent = expectedItems.every(key => Object.keys(jObj.request[0]).includes(key));
    if (!allItemsPresent) {
        message.error(
          t(
            `TRANSACTIONS:${TRANSACTIONS.PROVIDED_DATA_INVALID_ERROR_MESSAGE.key}`,
            TRANSACTIONS.PROVIDED_DATA_INVALID_ERROR_MESSAGE.value,
          ),
        );
        console.log("missing items :: ", expectedItems.filter(key => !Object.keys(jObj.request[0]).includes(key)));
        return;
    }

    const emptyContentNames = template.variableContract
      .filter(item => VARIABLE_OBJECT_TYPES.includes(item.type) && item.content && item.content.length === 0)
      .map(item => item.name);
    const emptyData = emptyContentNames.reduce((acc, name) => {
      return { [name]: [] };
    }, {});
    const payload = jObj.request.map((req, index) => {
      let {...rest} = req;
      let extraParams = {};
      if (isEmail) {
        let { toEmailAddress, attachmentPassword } = req;
        extraParams = {
          to: [toEmailAddress],
          attachmentPassword
        }
      }
      return {
        ...emptyData,
        ...extraParams,
        ...rest,
        id: index
      };    
    });
      const dataset =
        isRepeatedBlocks || isChartBlock
          ? generateRepeatedBlockPayload(payload, template, isEmail, tagsData)
          : generatePayload(payload, template, isEmail, tagsData);

      return dataset;
  }
  return false;
}